/*
* @Author: gujianghua
* @Date:   2018-07-21 18:00:58
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-31 17:52:45
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'
const v2 = BASE_API

export default {
	getCourseList: function getCourseList(data) {
		return service({
			url: '/cloud/course/v1/admin/course/pageList',
			method: 'post',
			data: data
		})
	},
    //分页获取课程学员列表
	getCourseMemberList: (data) => {
		return service({
			url: '/cloud/course/v1/admin/course/memberPageList',
			method: 'post',
			data: data
		})
	},
	// 学术分类树
	scholarshipTree: function scholarshipTree() {
		return service({
			url: '/cloud/course/v1/admin/mom/course/category/tree',
			method: 'get'
		})
	},
	deleteCourse(params) {
		return service({
			url: '/cloud/course/v1/admin/course/delete',
			method: 'post',
			params: params
		})
	},
	/**
	 * [addCourse 添加课程]
	 * @param {[obj]} data [课程信息]
	 */
	addCourse(data) {
		return service({
			url: '/cloud/course/v1/admin/course/create',
			method: 'post',
			data: data
		})
	},
	editCourse(data) {
		return service({
			url: '/cloud/course/v1/admin/course/modify',
			method: 'post',
			data: data
		})
	},
	getCourseDetail(params) {
		return service({
			url: '/cloud/course/v1/admin/course/findById',
			method: 'get',
			params: params
		})
	},
	getCourseRelate(params) {
		return service({
			url: '/cloud/course/v1/admin/course/associationSourceList',
			method: 'get',
			params: params
		})
	},
	// 上下架
	courseSwitch(data) {
		return service({
			url: '/cloud/course/v1/admin/course/offline',
			method: 'post',
			params: data
		})
	},
	/**
	 * [resetLive 重置直播]
	 * @param  {[obj]} params [id]
	 * @return {[obj]} 
	 */
	resetLive(params) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/reset',
			method: 'post',
			params: params
		})		
	},
	// 导入学员列表
	getMemberList(params) {
		return service({
			url: '/cloud/uac/mom/manage/common/momList',
			method: 'get',
			params: params
		})		
	},
	// 导入，列表形式
	exportList(params,data) {
		return service({
			url: '/cloud/course/v1/admin/course/importMemberList',
			method: 'post',
			params: params,
			data: data
		})		
	},
	// 导入，excel形式
	excelList: v2 + '/cloud/course/v1/admin/course/importMemberExcel',
	/**
	* [export 导出学员列表]
	* @param  {[obj]} data [筛选条件]
	* @return {[obj]}
	*/
	// exportExcel(data) {
	//     let url = v2 + '/cloud/course/v1/admin/course/memberExport?' +
	//       searchParamsFormatter(data)
	//     window.location.href = url
	// },
	
	exportExcel(params) {		
		return service({
			url: '/cloud/course/v1/admin/course/exportMMCourseMember',
			method: 'get',
			params,
			responseType: 'blob'
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/contentManage/momCourseManage.js